// Hero section data
export const heroData = {
  tag: "🔥 全网最速吃瓜",
  h1: "51吃瓜app — 全网热门吃瓜资讯聚合平台",
  slogan: "新鲜热瓜 · 每日更新 · 一网打尽",
  intro:
    "51吃瓜app是全网最新最全的娱乐吃瓜资讯聚合平台，每日追踪娱乐圈、网红圈、社交平台的热门话题与最新动态。我们汇聚全网讨论度最高的八卦事件，提供安全稳定的访问入口与轻量级APP下载，让你不错过任何一个值得关注的吃瓜时刻。",
  stats: [
    { label: "每日更新", value: "200+ 条" },
    { label: "覆盖平台", value: "30+ 个" },
    { label: "活跃瓜友", value: "500万+" },
  ],
  ctaPrimary: { text: "立即下载APP", href: "#app" },
  ctaSecondary: { text: "浏览最新吃瓜", href: "#cards" },
};

// FAQ section data - 6 items
export const faqData = [
  {
    q: "51吃瓜app是什么？",
    a: "51吃瓜app是一款专注于娱乐八卦、明星动态、网红热点和社交话题的资讯聚合平台。我们每日从各平台精选最热门的吃瓜内容，为用户提供一站式吃瓜体验，让八卦爱好者不再错过任何精彩内容。",
  },
  {
    q: "51吃瓜网站安全吗？",
    a: "51吃瓜网站高度重视用户安全与隐私保护。我们的入口经过多层安全加固，支持HTTPS加密访问，不存在恶意弹窗或诱导下载。建议通过官方入口访问以获取最佳安全体验。",
  },
  {
    q: "如何下载51吃瓜app轻量版？",
    a: "您可以访问本页面的APP下载专区，通过官方提供的下载入口获取51吃瓜轻量版。轻量版占用空间小、加载速度快，适合各类安卓设备安装使用，iOS用户可通过网页版直接访问。",
  },
  {
    q: "51吃瓜官网入口在哪里？",
    a: "本站即为51吃瓜官方网站入口。建议收藏本页面以随时获取最新地址。如遇到访问异常，可关注本页公告区获取最新可用入口信息。",
  },
  {
    q: "51吃瓜网的内容更新频率如何？",
    a: "我们保持7×24小时不间断更新，每日新增200+条吃瓜内容。热点事件发生30分钟内即可上线，确保你第一时间获取最新动态。所有内容经过多源交叉验证，拒绝虚假信息。",
  },
  {
    q: "可以投稿或提供线索吗？",
    a: "当然可以！我们欢迎广大瓜友踊跃投稿。您可以通过页面底部的联系我们专区提交线索或爆料，一经采用将标注来源并给予适当奖励。一起建设更精彩的吃瓜社区！",
  },
];

// Topics section data - 10 items
export const topicsData = [
  { name: "明星恋情", heat: "980万", tag: "hot", icon: "ri-heart-line" },
  { name: "综艺翻车", heat: "860万", tag: "trending", icon: "ri-live-line" },
  { name: "网红塌房", heat: "750万", tag: "hot", icon: "ri-alert-line" },
  { name: "影视吐槽", heat: "690万", tag: "new", icon: "ri-film-line" },
  { name: "饭圈大战", heat: "620万", tag: "trending", icon: "ri-fire-line" },
  { name: "直播事故", heat: "580万", tag: "hot", icon: "ri-vidicon-line" },
  { name: "品牌翻车", heat: "510万", tag: "new", icon: "ri-shopping-bag-line" },
  { name: "综艺CP", heat: "470万", tag: "normal", icon: "ri-heart-pulse-line" },
  { name: "音乐打榜", heat: "430万", tag: "normal", icon: "ri-music-line" },
  { name: "体育八卦", heat: "390万", tag: "normal", icon: "ri-basketball-line" },
];

// App download section data - 1 item
export const appData = {
  title: "51吃瓜APP — 轻量版下载",
  subtitle: "体积小 · 加载快 · 推送即时",
  description:
    "专为移动端优化的吃瓜神器，支持安卓系统一键安装。轻量版仅占用15MB空间，提供即时热点推送、离线阅读、夜间模式等实用功能，让你随时随地掌握最新吃瓜动态。",
  features: ["极速加载", "热点推送", "夜间模式", "离线缓存", "无广告（基础版）"],
  version: "v3.2.1",
  size: "15MB",
  updateDate: "2026年7月28日",
};

// Cards section data - 6 items
export const cardsData = [
  {
    title: "某顶流男星深夜密会被拍，工作室火速回应引热议",
    summary:
      "狗仔曝光的画面显示两人举止亲密，粉丝群体迅速分化，工作室凌晨发布声明否认恋情，但网友扒出更多细节佐证。",
    category: "明星八卦",
    time: "2小时前",
    heat: "980万",
  },
  {
    title: "热门综艺录制现场突发状况，导演组紧急叫停",
    summary:
      "某竞技类综艺最新一期录制中，嘉宾因道具问题发生意外，现场一度混乱。节目组已发布情况说明，确认无人受伤。",
    category: "综艺热点",
    time: "5小时前",
    heat: "860万",
  },
  {
    title: "知名网红直播翻车，账号疑似被封引全网围观",
    summary:
      "该网红在直播中因言论不当被平台强制下播，随后账号显示异常。事件的来龙去脉在多个社交平台持续发酵，话题阅读量破3亿。",
    category: "网红动态",
    time: "8小时前",
    heat: "750万",
  },
  {
    title: "暑期档电影票房大战：第一名花落谁家",
    summary:
      "今年暑期档竞争异常激烈，多部大片正面交锋。目前票房前三名差距极小，业内预测本周将出现逆转，吃瓜群众坐等好戏。",
    category: "影视追踪",
    time: "12小时前",
    heat: "620万",
  },
  {
    title: "某品牌代言人突然官宣换人，老代言人粉丝炸锅",
    summary:
      "品牌方在没有任何预兆的情况下宣布新代言人，前任代言人粉丝纷纷表示不满。业内人士透露合约早已到期，但品牌的处理方式引发讨论。",
    category: "品牌动态",
    time: "1天前",
    heat: "510万",
  },
  {
    title: "音乐节演出阵容曝光，神秘嘉宾身份引发竞猜",
    summary:
      "即将开幕的大型音乐节公布了首批演出阵容，其中一位以剪影形式出现的神秘嘉宾引发全网竞猜，评论区已经炸开了锅。",
    category: "音乐娱乐",
    time: "1天前",
    heat: "470万",
  },
];

// Updates section data - 8 items
export const updatesData = [
  {
    date: "07-30",
    title: "某女星深夜发文暗示婚变，评论区秒变修罗场",
    type: "明星动态",
  },
  {
    date: "07-30",
    title: "热门剧集大结局播出，观众对结局褒贬不一",
    type: "影视热议",
  },
  {
    date: "07-29",
    title: "电竞圈顶流选手宣布退役，粉丝哭成一片",
    type: "电竞新闻",
  },
  {
    date: "07-29",
    title: "某奢侈品牌新品发布会翻车，网友直呼辣眼睛",
    type: "品牌八卦",
  },
  {
    date: "07-28",
    title: "短视频平台头部创作者被指抄袭，双方互发律师函",
    type: "网红纠纷",
  },
  {
    date: "07-28",
    title: "某偶像团体成员单方面宣布退团，公司回应正在协商",
    type: "偶像动态",
  },
  {
    date: "07-27",
    title: "重量级颁奖典礼提名名单公布，多匹黑马杀出",
    type: "奖项追踪",
  },
  {
    date: "07-27",
    title: "社交平台热搜榜出现神秘关键词，全网都在问发生了什么",
    type: "热搜解码",
  },
];

// Ranking section data - 7 items
export const rankingData = [
  { rank: 1, title: "顶流男星深夜密会事件全记录", heat: "1280万", trend: "up" },
  { rank: 2, title: "综艺录制现场意外事故追踪", heat: "1150万", trend: "up" },
  { rank: 3, title: "知名网红直播翻车完整复盘", heat: "1020万", trend: "up" },
  { rank: 4, title: "暑期档电影票房实时战况", heat: "890万", trend: "down" },
  { rank: 5, title: "品牌代言人更换风波始末", heat: "760万", trend: "up" },
  { rank: 6, title: "音乐节神秘嘉宾身份猜测汇总", heat: "650万", trend: "new" },
  { rank: 7, title: "某女星婚变传闻线索梳理", heat: "540万", trend: "new" },
];

// Carousel section data - 4 items (static, all visible)
export const carouselData = [
  {
    title: "暑期档吃瓜指南：2026年最值得关注的十大娱乐事件",
    summary:
      "从顶流恋情到综艺翻车，从品牌代言到网红风波——我们为你梳理了今年夏天最火爆的娱乐话题，一网打尽不遗漏。",
    label: "专题策划",
    color: "from-primary-500 to-primary-700",
  },
  {
    title: "吃瓜术语大全：2026年最新网络黑话解读",
    summary:
      "塌房、翻车、锤了、实锤……吃瓜圈的暗号你认识几个？我们整理了今年最火的50个吃瓜专用词，一文学会全网通用。",
    label: "科普指南",
    color: "from-accent-500 to-accent-700",
  },
  {
    title: "从热搜到头条：揭秘一条吃瓜内容的传播路径",
    summary:
      "一个八卦如何在24小时内从匿名爆料登上热搜第一？我们追踪了三个月内最火的20条吃瓜内容的传播路径。",
    label: "深度分析",
    color: "from-secondary-600 to-secondary-800",
  },
  {
    title: "吃瓜经济学：娱乐八卦背后的流量与商业逻辑",
    summary:
      "为什么一个明星的恋爱新闻能创造数亿阅读量？我们拆解了吃瓜产业链的运作模式，看看娱乐八卦如何成为一门大生意。",
    label: "行业洞察",
    color: "from-primary-600 to-accent-600",
  },
];

// About section data - 1 item
export const aboutData = {
  title: "关于51吃瓜",
  description:
    "51吃瓜app诞生于2020年，是国内领先的娱乐八卦资讯聚合平台。我们以\"让吃瓜更简单\"为使命，通过自主研发的AI热点追踪系统，实时监测全网30+主流社交平台与资讯站点，确保用户第一时间获取最新、最全的吃瓜内容。平台目前累计服务超过500万用户，日均更新内容200+条，已成为国内吃瓜爱好者首选的资讯入口。",
  highlights: [
    { value: "500万+", label: "累计用户" },
    { value: "200+/天", label: "内容更新" },
    { value: "30+", label: "监测平台" },
    { value: "4年", label: "稳定运营" },
  ],
};

// Features section data - 3 items
export const featuresData = [
  {
    icon: "ri-flashlight-line",
    title: "极速追踪",
    desc: "自主研发AI热点监测系统，热点事件发生30分钟内即可上线，不错过任何精彩瞬间。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全可靠",
    desc: "全站HTTPS加密，严格审核内容来源，拒绝虚假信息和恶意弹窗，保障用户纯净浏览。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端适配",
    desc: "支持网页版、安卓APP及轻量版，iOS用户可通过Safari添加至主屏幕，全平台无缝覆盖。",
  },
];

// Media section data - 3 items
export const mediaData = [
  {
    title: "「吃瓜热榜TOP10」本周最火爆的十大娱乐事件回顾",
    duration: "15:42",
    views: "128万",
    category: "周榜盘点",
  },
  {
    title: "「深度拆解」某顶流恋爱瓜的时间线与证据链梳理",
    duration: "22:18",
    views: "96万",
    category: "深度分析",
  },
  {
    title: "「吃瓜脱口秀」2026上半年最离谱的20个娱乐事件",
    duration: "18:05",
    views: "85万",
    category: "趣味盘点",
  },
];

// Contact section data - 1 item
export const contactData = {
  title: "投稿爆料",
  description: "有猛料？有线索？欢迎联系51吃瓜编辑部。我们严格保护爆料者隐私，采用即付稿酬。",
  email: "tips@51chigua.com",
  response: "工作日24小时内回复",
};

// Index section data - 8 items
export const indexData = [
  { title: "明星恋情追踪", count: "128篇", icon: "ri-heart-line" },
  { title: "综艺节目吃瓜", count: "96篇", icon: "ri-tv-line" },
  { title: "网红达人动态", count: "85篇", icon: "ri-user-star-line" },
  { title: "影视剧集吐槽", count: "73篇", icon: "ri-clapperboard-line" },
  { title: "品牌代言风波", count: "61篇", icon: "ri-building-line" },
  { title: "音乐圈八卦", count: "54篇", icon: "ri-music-2-line" },
  { title: "电竞娱乐", count: "47篇", icon: "ri-gamepad-line" },
  { title: "海外吃瓜", count: "39篇", icon: "ri-global-line" },
];

// Comments section data - 4 items
export const commentsData = [
  {
    name: "吃瓜第一线",
    avatar: "R",
    time: "2小时前",
    content:
      "这个瓜我吃了三天了，越吃越上头！51吃瓜的整理速度真快，比我自己刷微博强太多了，推荐给所有吃瓜人。",
    likes: 328,
  },
  {
    name: "深夜吃瓜人",
    avatar: "Y",
    time: "5小时前",
    content:
      "从知乎过来的，看了那篇明星恋情的深度分析，写得真不错。现在每天睡前必刷一遍51吃瓜，已经成了习惯。",
    likes: 256,
  },
  {
    name: "八卦绝缘体",
    avatar: "B",
    time: "8小时前",
    content:
      "说实话以前对八卦不感兴趣，但是51吃瓜的内容做得太有意思了，我现在已经上瘾了哈哈哈哈，真香警告！",
    likes: 189,
  },
  {
    name: "老吃瓜人了",
    avatar: "L",
    time: "1天前",
    content:
      "用了快两年了，看着51吃瓜从一个小站做到现在。内容质量一直在线，更新速度也没掉过链子，希望越做越好！",
    likes: 412,
  },
];